import { Component, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { FormatService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { findIndex } from 'lodash';

@Component({
  selector: 'app-update-canned-service-dialog',
  templateUrl: './update-canned-service-dialog.component.html',
  styleUrls: ['./update-canned-service-dialog.component.scss'],
})
export class UpdateCannedServiceDialogComponent implements OnInit {
  // dialog provided data
  part: any = {};
  cannedServices: any = [];
  updatedFields: any = [];
  isSubmitting: boolean = false;
  isPassThroughTax: boolean = false;
  from: any = '';
  usd: string = currency.USD;
  itemTypeOption = {
    flatRate: 'Flat rate item:',
    service: 'Canned service:',
  };

  isAllServiceSelected: boolean = false;

  constructor(public ref: DynamicDialogRef, public dConfig: DynamicDialogConfig, public dialogService: DialogService, public helperService: HelperService, public httpService: HTTPService, private formatService: FormatService) { }

  ngOnInit() {
    const { part, cannedServices = [], updatedFields = [], from } = this.dConfig.data;
    // part can be labor, tire, or part
    this.part = part;
    this.cannedServices = cannedServices;
    this.isPassThroughTax = part.isPassThroughTax
    this.updatedFields = updatedFields;
    this.from = from;
    // Map item fields to required
    if (this.part.billableHours != null && this.part.billableHours != undefined) {
      this.part.count = this.part.billableHours;
      // if updated fields includes billableHours it means count must be updated as well
      if (this.updatedFields.includes('billableHours')) {
        this.updatedFields.push('count');
      }
    }
    // in case rate change
    if (this.part.costRate != null && this.part.costRate != undefined) {
      this.part.costRate = this.part.costRate;

      // if updated fields includes billableHours it means count must be updated as well
      if (this.updatedFields.includes('costRate') || this.updatedFields.includes('cost') || this.updatedFields.includes('costEstimatedHours')) {
        this.updatedFields.push('costRate');
      }
    }
    if (this.part.notes != null && this.part.notes != undefined) {
      this.part.description = this.part.notes;
      // if updated fields includes notes it means description must be updated as well
      if (this.updatedFields.includes('notes')) {
        this.updatedFields.push('description');
      }
    }
    // incase of labor if bill rate is updated change it
    if (this.updatedFields.includes('billRate')) {
      if (findIndex(this.updatedFields, 'price') < 0) {
        this.updatedFields.push('price');
      }
      this.part.price = this.part.billRate || 0;
    }

    // for each canned service update items to only current target item list
    // also add an update flag so that this same flag can be used for update
    this.cannedServices = this.cannedServices.map((service) => {
      service.isUpdateCannedService = true;
      if (!service.items || !Array.isArray(service.items)) service.items = [];
      else service.items = service.items.filter((i) => i.itemId === this.part._id);
      // also check if current service has multiple items
      return service;
    });

    if (this.cannedServices && this.cannedServices.length) {
      this.isAllServiceSelected = this.cannedServices.every((service: any) => service.isUpdateCannedService === true);
    }
  }

  /**
   * Handle checkbox change for service
   * @param serviceId
   * @param $event
   */
  handleCheckBox(serviceId, $event) {
    try {
      this.cannedServices.forEach((service, index) => {
        if (service._id === serviceId) {
          this.cannedServices[index].isUpdateCannedService = $event || $event.checked;
        }
      });
      if (this.cannedServices && this.cannedServices.length) {
        this.isAllServiceSelected = this.cannedServices.every((service: any) => service.isUpdateCannedService === true);
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  handleAllSelect(event: any) {
    if (this.cannedServices && this.cannedServices.length) {
      this.cannedServices.forEach((service: any) => {
        service.isUpdateCannedService = event || event.checked;
      });
      this.isAllServiceSelected = event || event.checked;
    }
  }

  /**
   * Get value for first item in service
   */
  renderFieldData(item, field) {
    if (field === 'isTaxable') return item && item[field] ? 'Yes' : 'No';
    return item && item[field] && item[field] !== '' ? item[field] : ' ';
  }

  /**
   * Check if a field is updated
   */
  isFieldUpdated(field) {
    if (field === 'subTotal') {
      return this.updatedFields.includes('price') || this.updatedFields.includes('count');
    }
    return this.updatedFields.includes(field);
  }

  /**
   * Clost Dialog
   * @param data
   */
  closeDialog(data: any) {
    this.ref.close(data);
  }

  showToolTip(field, item?) {
    let fieldTitle = field;
    let fieldValue = this.part[field];
    if (!this.isFieldUpdated(field)) {
      return;
    }
    if (field === 'isTaxable') {
      fieldTitle = 'Taxable';
      let html = `<div class="tool-tip-row flex-start-center">This item will be marked as ${fieldValue ? 'Taxable' : 'Nontaxable'}</div>`;
      return html;
    }
    else if (field === 'count') {
      fieldTitle = 'Qty/Hr';
      // fieldValue = this.part['billableHours'];
      if (!fieldValue) {
        return;
      }
    } else if (field === 'costRate') {
      fieldTitle = 'Unit cost';
      // fieldValue = this.part['billableHours'];
      const price = this.updatedFields.includes('costRate') ? this.part.costRate || 0 : item.costRate || 0;
      // const count = this.updatedFields.includes('count') ? this.part.count || 0 : item.count || 0;
      fieldValue = price;
    } else if (field === 'subTotal') {
      const price = this.updatedFields.includes('price') ? this.part.price || 0 : item.price || 0;
      const count = this.updatedFields.includes('count') ? this.part.count || 0 : item.count || 0;
      fieldValue = price * count;
    }
    let html = `<div class="tool-tip-row flex-start-center">The ${fieldTitle} will be updated to: ${fieldValue}</div>`;
    return html;
  }

  async onSubmit() {
    try {
      this.isSubmitting = true;
      // construct payload
      const payload = <any>{
        services: this.cannedServices
          .filter((c) => c.isUpdateCannedService)
          .map((c: any) => {
            return {
              _id: c._id,
              itemType: c.itemType,
            };
          }),
        itemId: this.part._id,
        isPassThroughTax: this.isPassThroughTax
      };

      if (this.isFieldUpdated('description')) {
        payload.description = this.part.description;
      }
      if (this.isFieldUpdated('price')) {
        payload.price = this.part.price;
      }
      if (this.isFieldUpdated('isTaxable')) {
        payload.isTaxable = this.part.isTaxable;
      }
      if (this.isFieldUpdated('cost')) {
        payload.cost = this.part.cost;
      }
      if (this.isFieldUpdated('count')) {
        payload.count = this.part.count;
      }
      if (this.isFieldUpdated('costRate')) {
        payload.cost = this.part.costRate * this.part.costEstimatedHours;
        payload.costRate = this.part.costRate;
        payload.costEstimatedHours = this.part.costEstimatedHours;
      }
       
      if (this.isFieldUpdated('flatRate')) {
        payload.price = this.part.flatRate;
      }
      // in case of tire add cost on place of costRate
      if (this.part.type === 'tire') {
        payload.cost = payload.costRate;
        delete payload.costRate;
      }
      
      if(this.part.type !== 'labor'){
        payload.cost = this.formatService.setDynamicCostAndPrice(this.part, 'cost');
      }

      await this.httpService.updateCannedServicesByItem(payload);
      this.helperService.showToaster('success', 'Update Successful');
      this.closeDialog(true);
    } catch (error) {
      this.helperService.showToaster('error', error);
    } finally {
      this.isSubmitting = false;
    }
  }
}
